module.exports = __webpack_public_path__ + "img/215.problem_handle_door.f9bbf8c7.svg";